const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
};

// TODO: Update font-size based on layout
document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	cardsFound: 0,
	cards: [
		{ id: 1, img: "./img/cartes/1-carte.png", imgOff: "./img/cartes/1-carte-off.png", imgAnswer: "./img/answers/1-3-boites-medicament.png", positions: [9, 12] },
		{ id: 2, img: "./img/cartes/2-carte.png", imgOff: "./img/cartes/2-carte-off.png", imgAnswer: "./img/answers/2-1-boite-medicament.png", positions: [1, 8] },
		{ id: 3, img: "./img/cartes/3-carte.png", imgOff: "./img/cartes/3-carte-off.png", imgAnswer: "./img/answers/3-logo-sourcing.png", positions: [3, 5] },
		{ id: 4, img: "./img/cartes/4-carte.png", imgOff: "./img/cartes/4-carte-off.png", imgAnswer: "./img/answers/4-gelule.png", positions: [7, 20] },
		{ id: 5, img: "./img/cartes/5-carte.png", imgOff: "./img/cartes/5-carte-off.png", imgAnswer: "./img/answers/5-avocat.png", positions: [0, 11] },
		{ id: 6, img: "./img/cartes/6-carte.png", imgOff: "./img/cartes/6-carte-off.png", imgAnswer: "./img/answers/6-soja.png", positions: [10, 13] },
		{ id: 7, img: "./img/cartes/7-carte.png", imgOff: "./img/cartes/7-carte-off.png", imgAnswer: "./img/answers/7-1-gelule-par-jour.png", positions: [6, 21] },
		{ id: 8, img: "./img/cartes/8-carte.png", imgOff: "./img/cartes/8-carte-off.png", imgAnswer: "./img/answers/8-Expanscience-Laboratoires.png", positions: [2, 15] },
		{ id: 9, img: "./img/cartes/9-carte.png", imgOff: "./img/cartes/9-carte-off.png", imgAnswer: "./img/answers/9-France.png", positions: [17, 22] },
		{ id: 10, img: "./img/cartes/10-carte.png", imgOff: "./img/cartes/10-carte-off.png", imgAnswer: "./img/answers/10-Personnages.png", positions: [4, 19] },
		{ id: 11, img: "./img/cartes/11-carte.png", imgOff: "./img/cartes/11-carte-off.png", imgAnswer: "./img/answers/11-enceinte.png", positions: [14, 23] },
		{ id: 12, img: "./img/cartes/12-carte.png", imgOff: "./img/cartes/12-carte-off.png", imgAnswer: "./img/answers/12-Piascledine300.png", positions: [16, 18] },
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this.renderBoard();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				this.resultSelectedCard = 1;
				this.renderResultsBoard();
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	hiddenCardImg: "<img src='./img/cartes/carte-off.png' />",
	renderBoard() {
		const container = document.getElementById("game-memory-grid");

		let spots = [];
		this.cards.forEach((card) => {
			card.positions.forEach(position => {
				spots[position] = `<div class='memory-card' 
	id="card-${card.id}-${position}"
	style="grid-row: ${Math.floor(position / 6) + 1}; grid-column: ${position % 6 + 1}"
	onclick='Game.answer(event, ${card.id})'
>${this.hiddenCardImg}</div>`;
			});
		});

		container.innerHTML = spots.join("");
	},
	resultSelectedCard: 1,
	resultNext() {
		this.resultSelectedCard += 1;
		this.renderResultsBoard();
	},
	resultPrevious() {
		if (this.resultSelectedCard === 1) {
			this.state = GameState.done;
			this.render();
			return;
		}
		this.resultSelectedCard -= 1;
		this.renderResultsBoard();
	},
	resultSelect(id) {
		this.resultSelectedCard = id;
		this.renderResultsBoard();
	},
	renderResultsBoard() {
		const container = document.getElementById("results-memory-grid");

		// Render grid
		let spots = [];
		this.cards.forEach((card) => {
			card.positions.forEach(position => {
				spots[position] = `<div class='memory-card' 
	id="card-${card.id}-${position}"
	style="grid-row: ${Math.floor(position / 6) + 1}; grid-column: ${position % 6 + 1}"
	onclick='Game.resultSelect(${card.id})'
><img src="${this.resultSelectedCard === card.id ? card.img : card.imgOff}" /></div>`;
			});
		});
		container.innerHTML = spots.join("");

		// Render answer
		const card = this.cards.find(c => c.id === this.resultSelectedCard);
		const answerDiv = document.createElement("div");
		answerDiv.id = "answer";

		const answerImg = document.createElement("img");
		answerImg.src = card.imgAnswer;

		answerDiv.appendChild(answerImg);

		container.appendChild(answerDiv);

		// Show the right buttons
		// Always show previous
		document.getElementById("footer-previous").classList = "";

		// Next & restart based on current card
		if (this.resultSelectedCard === this.cards[this.cards.length - 1].id) {
			document.getElementById("footer-next").classList = "hidden";
			document.getElementById("footer-restart").classList = "";
		} else {
			document.getElementById("footer-next").classList = "";
			document.getElementById("footer-restart").classList = "hidden";
		}
	},
	isPaused: false,
	selectedCardDiv: null,
	selectedCardId: null,
	matchSelectedCardDiv: null,
	answer(event, cardId) {
		if (this.isPaused) { return; }
		this.isPaused = true;

		const memoryCardDiv = event.currentTarget;
		const card = this.cards.find(c => c.id === cardId);

		// Ensure we can't click twice on the same item
		if (memoryCardDiv.id === this.selectedCardDiv?.id) {
			this.isPaused = false;
			return;
		}

		// Return current card anyway
		memoryCardDiv.innerHTML = `<img src="${card.img}" />`;

		if (!this.selectedCardDiv) {
			// First card selected, store & return
			this.selectedCardDiv = memoryCardDiv;
			this.selectedCardId = cardId;
			this.isPaused = false;
			return;
		}

		if (this.selectedCardId !== cardId) {
			// Failure
			// Todo: Show oups toastr ?
			const errorDiv = document.createElement('div')
			errorDiv.innerHTML = "Oups ! Ce n'est pas ici.";
			errorDiv.setAttribute("id", "error-message");
			memoryCardDiv.appendChild(errorDiv);

			setTimeout(() => {
				// Return cards
				this.selectedCardDiv.innerHTML = this.hiddenCardImg;
				memoryCardDiv.innerHTML = this.hiddenCardImg;

				// Reset game state
				this.selectedCardId = null;
				this.selectedCardDiv = null;
				this.isPaused = false;
			}, 2000);
			return;
		}

		// Success
		this.matchSelectedCardDiv = memoryCardDiv; // So we can disabled them in this.next

		// Show answer
		const grid = document.getElementById("game-memory-grid");

		const answerDiv = document.createElement("div");
		answerDiv.id = "answer";

		const answerImg = document.createElement("img");
		answerImg.src = card.imgAnswer;
		answerImg.onclick = this.next.bind(this);

		const nextButton = document.createElement("a");
		nextButton.innerHTML = `<img src="./img/buttons/suivant-orange.png" />`;
		nextButton.onclick = this.next.bind(this);

		answerDiv.appendChild(answerImg);
		answerDiv.appendChild(nextButton);

		grid.appendChild(answerDiv);
	},
	next() {
		this.cardsFound += 1;

		// Disable cards
		this.selectedCardDiv.classList.add("found");
		this.matchSelectedCardDiv.classList.add("found");

		// Reset game state
		this.selectedCardId = null;
		this.selectedCardDiv = null;
		this.matchSelectedCardDiv = null;
		this.isPaused = false;

		document.getElementById("answer").remove();

		if (this.cardsFound === this.cards.length) {
			console.log("Done state");
			this.state = GameState.done;
			this.render();
		}
	},
	restart() {
		this.isPaused = false;
		this.cardsFound = 0;
		this.selectedCardDiv = null;
		this.selectedCardId = null;
		this.matchSelectedCardDiv = null;
		this.resultSelectedCard = 1;
		this.state = GameState.playing;
		this.render();
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();
addEventListener('resize', document.computeSizes);
